




import { Vue, Component, Prop } from "vue-property-decorator";

export type FaType = "solid" | "s" | "regular" | "r" | "light" | "l" | "duotone" | "d" | "brand" | "b";
export type FaSize = "xs" | "sm" | "lg" | "2x" | "3x" | "4x" | "5x" | "7x" | "10x";
export type FaRotate = "90" | "180" | "270";
export type FaFlip = "horizontal" | "vertical" | "both";

const types = ["solid", "s", "regular", "r", "light", "l", "duotone", "d", "brand", "b"];
const sizes = ["xs", "sm", "lg", "2x", "3x", "4x", "5x", "7x", "10x"];
const rotates = ["90", "180", "270"];
const flips = ["horizontal", "vertical", "both"];

@Component
export default class FaIcon extends Vue {
	@Prop({ type: String, required: true })
	public icon!: string;

	@Prop({ validator: (value) => types.includes(value), default: "solid" })
	public type!: FaType;

	@Prop({ type: Boolean, default: false })
	public unfixedWidth!: boolean;

	@Prop({ type: Boolean, default: false })
	public spin!: boolean;

	@Prop({ type: Boolean, default: false })
	public pulse!: boolean;

	@Prop({ type: Boolean, default: false })
	public pullLeft!: boolean;

	@Prop({ type: Boolean, default: false })
	public pullRight!: boolean;

	@Prop({ type: Boolean, default: false })
	public border!: boolean;

	@Prop({ validator: (value) => value === null || sizes.includes(value), default: null })
	public size!: FaSize | null;

	@Prop({ validator: (value) => value === null || flips.includes(value), default: null })
	public flip!: FaFlip | null;

	@Prop({ validator: (value) => !value || rotates.includes(value.toString()), default: null })
	public rotate!: FaRotate | null;

	@Prop({ type: Boolean, default: false })
	public swapOpacity!: boolean;

	@Prop({ validator: (value) => value >= 0 && value <= 1, default: null })
	public primaryOpacity!: number | null;

	@Prop({ validator: (value) => value >= 0 && value <= 1, default: null })
	public secondaryOpacity!: number | null;

	@Prop({ type: String, default: null })
	public primaryColor!: string | null;

	@Prop({ type: String, default: null })
	public secondaryColor!: string | null;

	public get classes() {
		let classes = [
			{
				"fal": this.type === "light" || this.type === "l",
				"fad": this.type === "duotone" || this.type === "d",
				"fab": this.type === "brand" || this.type === "b",
				"far": this.type === "regular" || this.type === "r",
				"fas": this.type === "solid" || this.type === "s",
				"fa-fw": !this.unfixedWidth,
				"swap-opacity": this.swapOpacity,
				"fa-spinner": this.spin,
				"fa-pulse": this.pulse,
				"fa-pull-left": this.pullLeft,
				"fa-pull-right": this.pullRight,
				"fa-border": this.border,
			},
			"fa-" + this.icon,
		];
		if (this.size) {
			classes.push("fa-" + this.size);
		}
		if (this.flip) {
			classes.push("fa-flip-" + this.flip);
		}
		if (this.rotate) {
			classes.push("fa-rotate-" + this.rotate);
		}
		return classes;
	}

	public get styles() {
		let styles = {};
		if (this.primaryColor) {
			styles['--fa-primary-color'] = this.primaryColor;
		}
		if (this.secondaryColor) {
			styles['--fa-secondary-color'] = this.secondaryColor;
		}
		if (this.primaryOpacity) {
			styles['--fa-primary-opacity'] = this.primaryOpacity;
		}
		if (this.secondaryOpacity) {
			styles['--fa-secondary-opacity'] = this.secondaryOpacity;
		}
		return styles;
	}
}
